import React from "react";

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  role?: string;
}

export const GlassCard = ({
  children,
  className = "",
  onClick,
  role,
}: GlassCardProps) => (
  <div
    onClick={onClick}
    role={role}
    className={`bg-white dark:bg-slate-800 dark:backdrop-blur-xl border border-gray-200 dark:border-white/10 rounded-2xl shadow-lg dark:shadow-xl overflow-hidden transition-all duration-200 ${
      onClick
        ? "cursor-pointer hover:shadow-xl dark:hover:shadow-2xl hover:scale-[1.01] active:scale-[0.99] hover:bg-gray-50/80 dark:hover:bg-slate-700/80"
        : ""
    } ${className}`}
  >
    {children}
  </div>
);
